import * as media from '../../assets/career/media';

export interface ICareerPost {
  title: string;
  source: string;
  duration: string;
  href: string;
  action: string;
  image: string;
  srcSet: string;
}
export const posts: readonly ICareerPost[] = [
  {
    title: 'Границы применимости, вызовы и риски Backend-driven UI',
    source: 'vk видео',
    duration: '44 мин',
    href: 'https://vkvideo.ru/video-115699231_456240233?list=ln-zdD5WMrVnvARe4A2F7',
    action: 'Смотреть',
    image: media.blogImage3,
    srcSet: [
      media.blogImage3P500 + ' 500w',
      media.blogImage3P800 + ' 800w',
      media.blogImage3P1080 + ' 1080w',
      media.blogImage3P1600 + ' 1600w',
      media.blogImage3 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'AntiSOLID',
    source: 'YouTube',
    duration: '49 мин',
    href: 'https://youtu.be/JIDoxJpgBTo?si=LcxgqYW5GZ_K_RCs',
    action: 'Смотреть',
    image: media.blogImage1,
    srcSet: [
      media.blogImage1P500 + ' 500w',
      media.blogImage1P800 + ' 800w',
      media.blogImage1P1080 + ' 1080w',
      media.blogImage1P1600 + ' 1600w',
      media.blogImage1 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'От технического долга к бизнес-целям: рефакторинг архитектуры в реальном кейсе',
    source: 'vk видео',
    duration: '46 мин',
    href: 'https://vkvideo.ru/video-115699231_456240234?list=ln-fh8QCLzj0caYQbewoq',
    action: 'Смотреть',
    image: media.blogImage2,
    srcSet: [
      media.blogImage2P500 + ' 500w',
      media.blogImage2P800 + ' 800w',
      media.blogImage2P1080 + ' 1080w',
      media.blogImage2P1600 + ' 1600w',
      media.blogImage2 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'Внедрение Data Catalog в Циан: наш путь прозначности работы с данными',
    source: 'vk видео',
    duration: '44 мин',
    href: 'https://vkvideo.ru/video-115699231_456240232?list=ln-4HcJbweAzgUlRaiWW5',
    action: 'Смотреть',
    image: media.blogImage5,
    srcSet: [
      media.blogImage5P500 + ' 500w',
      media.blogImage5P800 + ' 800w',
      media.blogImage5P1080 + ' 1080w',
      media.blogImage5P1600 + ' 1600w',
      media.blogImage5 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'Оптимизация PostgreSQL-запросов: всё, что нужно знать на практике',
    source: 'YouTube',
    duration: '44 мин',
    href: 'https://www.youtube.com/watch?v=mvlYrXmz2sg',
    action: 'Смотреть',
    image: media.blogImage6,
    srcSet: [
      media.blogImage6P500 + ' 500w',
      media.blogImage6P800 + ' 800w',
      media.blogImage6P1080 + ' 1080w',
      media.blogImage6P1600 + ' 1600w',
      media.blogImage6 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'Зачем нам Techlead и кто его привёл?',
    source: 'vk видео',
    duration: '120 мин',
    href: 'https://vkvideo.ru/video-115699231_456240230?list=ln-wgJrpmq1zGMTgZQYil',
    action: 'Смотреть',
    image: media.blogImage4,
    srcSet: [
      media.blogImage4P500 + ' 500w',
      media.blogImage4P800 + ' 800w',
      media.blogImage4P1080 + ' 1080w',
      media.blogImage4P1600 + ' 1600w',
      media.blogImage4 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'LLM Gateway в Циан: наводим порядок в работе с языковыми моделями',
    source: 'YouTube',
    duration: '41 мин',
    href: 'https://www.youtube.com/watch?v=Y7IxD-ys-Hw',
    action: 'Смотреть',
    image: media.blogImage8,
    srcSet: [
      media.blogImage8P500 + ' 500w',
      media.blogImage8P1080 + ' 1080w',
      media.blogImage8P1600 + ' 1600w',
      media.blogImage8 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'Управление жизненным циклом модели через Jira',
    source: 'YouTube',
    duration: '47 мин',
    href: 'https://youtu.be/ADPictoWGGs?si=vazm_2T3Ub9QaqYX',
    action: 'Смотреть',
    image: media.blogImage7,
    srcSet: [
      media.blogImage7P500 + ' 500w',
      media.blogImage7P800 + ' 800w',
      media.blogImage7P1080 + ' 1080w',
      media.blogImage7P1600 + ' 1600w',
      media.blogImage7 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'Миграция микросервисов на Python с помощью LLM: экономим месяцы для разработчиков',
    source: 'Хабр',
    duration: '6 мин',
    href: 'https://habr.com/ru/companies/cian/articles/1037986/',
    action: 'Читать',
    image: media.blogImage9,
    srcSet: [
      media.blogImage9P500 + ' 500w',
      media.blogImage9P800 + ' 800w',
      media.blogImage9P1080 + ' 1080w',
      media.blogImage9 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'Дедупликация объявлений: как мы боремся с одинаковыми размещениями',
    source: 'Хабр',
    duration: '13 мин',
    href: 'https://habr.com/ru/companies/cian/articles/892650/',
    action: 'Читать',
    image: media.blogImage11,
    srcSet: [
      media.blogImage11P500 + ' 500w',
      media.blogImage11P800 + ' 800w',
      media.blogImage11P1080 + ' 1080w',
      media.blogImage11 + ' 1920w',
    ].join(', '),
  },
  {
    title: 'Фокус-фактор: почему у разработчика никогда нет 40 часов на задачи',
    source: 'Хабр',
    duration: '10 мин',
    href: 'https://habr.com/ru/companies/cian/articles/980248/',
    action: 'Читать',
    image: media.blogImage10,
    srcSet: [
      media.blogImage10P500 + ' 500w',
      media.blogImage10P800 + ' 800w',
      media.blogImage10P1080 + ' 1080w',
      media.blogImage10 + ' 1920w',
    ].join(', '),
  },
];
